import {
    axisBottom,
    axisLeft,
    axisRight,
    axisTop,
} from "d3-axis"
import {select} from "d3-selection"
import {number} from "localization"
import React from "react"

class Axis extends React.Component {
    constructor() {
        super()
        this.node = React.createRef()
    }

    wrap = (text, width) => {
        text.each(function () {
            let text = select(this),
                words = text.text().split(/\s+/).reverse(),
                word,
                line = [],
                lineNumber = 0,
                lineHeight = 1.1, // ems
                y = text.attr("y"),
                dy = parseFloat(text.attr("dy")),
                tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em")
            while (word = words.pop()) {
                if (word.length) {
                    line.push(word)
                    tspan.text(line.join(" "))
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop()
                        tspan.text(line.join(" "))
                        line = [word]
                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", lineNumber++ * lineHeight + dy + "em").text(word)
                    }
                }
            }
        })
    }

    componentDidMount() {
        this.renderAxis()
    }

    componentDidUpdate() {
        this.renderAxis()
    }

    renderAxis() {
        const {scale, orient, valueType, selectedLanguage, highAmount} = this.props

        function findMaxAmountUnit(value) {
            if (selectedLanguage === "en") {
                if (Math.abs(Number(value)) >= 1.0e9) {
                    return "Bn"
                } else if (Math.abs(Number(value)) >= 1.0e6) {
                    return "M"
                } else if (Math.abs(Number(value)) >= 1.0e3) {
                    return "K"
                } else {
                    return "Ruppes"
                }
            } else {
                if (Math.abs(Number(value)) >= 1.0e7) {
                    return "करोड"
                } else if (Math.abs(Number(value)) >= 1.0e5) {
                    return "लाख"
                } else if (Math.abs(Number(value)) >= 1.0e3) {
                    return "हजार"
                } else {
                    return "रुपैयाँ"
                }
            }
        }

        function convertToMaxAmountUnit(value, maxAmountUnit) {
            if (selectedLanguage === "en") {
                if (maxAmountUnit === "Bn") {
                    return Number((Math.abs(Number(value)) / 1.0e+9).toFixed(1))
                } else if (maxAmountUnit === "M") {
                    return Number((Math.abs(Number(value)) / 1.0e+6).toFixed(1))
                } else if (maxAmountUnit === "K") {
                    return Number((Math.abs(Number(value)) / 1.0e+9).toFixed(1))
                }
            }
            if (selectedLanguage === "np") {
                if (maxAmountUnit === "करोड") {
                    return number(Number((Math.abs(Number(value)) / 1.0e7).toFixed(1)))
                } else if (maxAmountUnit === "लाख") {
                    return number(Number((Math.abs(Number(value)) / 1.0e5).toFixed(1)))
                } else if (maxAmountUnit === "हजार") {
                    return number(Number((Math.abs(Number(value)) / 1.0e3).toFixed(1)))
                } else {
                    return number(value)
                }
            }
        }

        let axis

        if (orient === "top") {
            axis = axisTop(scale)
        }

        if (orient === "right") {
            axis = axisRight(scale)
                .ticks(5).outerTickSize(0)
        }

        if (orient === "bottom") {
            axis = axisBottom(scale)
        }

        if (orient === "left") {
            axis = axisLeft(scale)
                .ticks(5)
        }

        if (valueType === "amount") {
            const maxAmountUnit = findMaxAmountUnit(highAmount)

            axis.tickFormat(d => {
                return convertToMaxAmountUnit(d, maxAmountUnit)
            })
        }

        if (valueType === "number") {
            axis.tickFormat(d => number(d))
        }

        select(this.node).call(axis)
        select(this.node).selectAll(".tick text").call(g => this.wrap(g, 10))
    }

    render() {
        const {orient, transform} = this.props
        return (
            <g

                width="100"
                ref={node => {
                    this.node = node
                }}
                transform={transform}
                className={`${orient}-axis`}
            />
        )
    }
}

export default Axis



// WEBPACK FOOTER //
// ./src/components/charts/common/axis/axis.js